import { Component, h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'
import {Bookmark} from "./BookmarkManager";

interface Props {
  onClose: () => void
  onCreate: (bookmark: Bookmark) => void
  error: string
}

interface State {
  bookmarkTitle: string
}

export default class CreateBookmarkModal extends Component<Props, State> {
  private input: HTMLInputElement | null | undefined

  constructor () {
    super()
    this.state = {
      bookmarkTitle: '',
    }
    this.onCreate = this.onCreate.bind(this)
  }

  componentDidMount(): void {
    this.input && this.input!.focus()
  }

  onCreate () {
    const { onCreate } = this.props
    const { bookmarkTitle} = this.state

    const bookmark: Bookmark = {
      title: bookmarkTitle
    }

    onCreate(bookmark)
  }

  render (props: Props, state: State) {
    const { onClose, error } = props
    const { bookmarkTitle } = state

    return <Modal isOpen>
      <ModalHeader title='Create Bookmark' onClose={onClose} />
      <ModalBody>
        <InputGroup
          required
          title={'Bookmark name'}
          type={'text'}
          value={bookmarkTitle}
          onChangeCallback={(e: ChangeEvent) => this.setState({ bookmarkTitle: e.target.value })}
          error={error}
          ref={(inputGroup: Component) => { if (inputGroup) this.input = inputGroup.base!.querySelector('input')}}
        />
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Create' variant='primary' onClick={() => this.onCreate()} />
        <ButtonControl title='Cancel' onClick={props.onClose} />
      </ModalFooter>
    </Modal>
  }
}
